const initState = {
  tasks: [],
  tasksToProject: [],
  taskSearchKeyword: ''
}

const tasksReducer = (state = initState, action) => {
  switch (action.type) {
    case 'FETCH_TASKS':
      return {
        ...state,
        tasks: action.tasks
      }
    case 'ADD_TASKS_TO_PROJECT':
      if (action.actionItem === "add") {
        return {
          ...state, 
          tasksToProject: [...state.tasksToProject, action.taskId]
        }
      }
      else {
        const bulkTasks = state.tasksToProject;
        const newBulkTasks = bulkTasks.filter( (taskId) => {
          if (taskId !== action.taskId) {
            return taskId;
          }

          return null;
        });
        return {
          ...state,
          tasksToProject: newBulkTasks
        }
      }
    case 'SET_TASK_SEARCH_KEYWORD':
      return {
        ...state,
        taskSearchKeyword: action.keyword 
      }
    case 'RESET_TASKS_TO_PROJECT':
      return {
        ...state, 
        tasksToProject: [] 
      }
    case 'CLEAR_SEARCH_KEYWORD':
      return {
        ...state, 
        taskSearchKeyword: ''
      }
    default: 
      return state;
  }
}

export default tasksReducer